import AttachmentModel from "./AttachmentModel";
import CategoryModel from "../CategoryModel";
export default class TicketModel {
  id: string | null;
  title: string | null;
  status: string | null;
  workorder_created_at: string | null;
  workorder_created_at_format: string | null;
  activitymaintenance: string | null;
  workcenter: string | null;
  activemenu: unknown | null;
  subject: string | null;
  description: string | null;
  machines_id: string | null;
  ticket_categories_id: number | null;
  urgency_level: string | null;
  tiket_status: string | null;
  assign_to: string | null;
  json_meta: string | null;
  issued_by: string | null;
  attachment: AttachmentModel[];
  categories: CategoryModel[];
  deleted_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  ref_regions_id: string | null;
  ref_locations_id: string | null;
  ref_equipment_id: string | null;
  closed: boolean | null;
  fl_area_code: string | null;
  fl_section_code: string | null;
  fl_line_code: string | null;
  fl_sub_line_code: string | null;
  fl_equipment_code: string | null;
  telegram_phone: string | null;
  telegram_id: string | null;
  problem_description: string | null;
  detail_description: string | null;
  
  constructor() {
    this.id = null;
    this.title = null;
    this.status = null;
    this.workorder_created_at = null;
    this.workorder_created_at_format = null;
    this.activitymaintenance = null;
    this.workcenter = null;
    this.activemenu = null;
    this.subject = null;
    this.description = null;
    this.machines_id = null;
    this.ticket_categories_id = null;
    this.urgency_level = null;
    this.tiket_status = null;
    this.assign_to = null;
    this.json_meta = null;
    this.issued_by = null;
    this.attachment = [];
    this.categories = [];
    this.deleted_at = null;
    this.created_at = null;
    this.updated_at = null;
    this.ref_regions_id = null;
    this.ref_locations_id = null;
    this.ref_equipment_id = null;
    this.closed = null;
    this.fl_area_code = null;
    this.fl_section_code = null;
    this.fl_line_code = null;
    this.fl_sub_line_code = null;
    this.fl_equipment_code = null;
    this.telegram_phone = null;
    this.telegram_id = null;
    this.problem_description = null;
    this.detail_description = null;

  }
}
